import { render, staticRenderFns } from "./VerClientesPrescriptions.vue?vue&type=template&id=787258ea&scoped=true&"
import script from "./VerClientesPrescriptions.vue?vue&type=script&lang=js&"
export * from "./VerClientesPrescriptions.vue?vue&type=script&lang=js&"
import style0 from "./VerClientesPrescriptions.vue?vue&type=style&index=0&id=787258ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787258ea",
  null
  
)

export default component.exports